const ENV_SITE_URL =
  import.meta.env.VITE_APP_URL ||
  import.meta.env.VITE_PUBLIC_SITE_URL ||
  import.meta.env.VITE_SITE_URL;
const ENV_APP_BASE_PATH = import.meta.env.VITE_APP_BASE_PATH;

const normalizeBaseUrl = (value: string) => value.trim().replace(/\/+$/, "");
const normalizeOriginPath = (value: string) => {
  if (!value) return "/";
  if (value.startsWith("/")) return value;
  return `/${value}`;
};
const normalizeBasePath = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed || trimmed === "/") return "";
  const withLeadingSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return withLeadingSlash.replace(/\/+$/, "");
};
const normalizeAppPath = (value: string) => {
  if (!value) return "/";
  if (value.startsWith("/")) return value;
  return `/${value}`;
};

export const getSiteUrl = () => {
  if (ENV_SITE_URL && /^https?:\/\//i.test(ENV_SITE_URL)) {
    return normalizeBaseUrl(ENV_SITE_URL);
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return normalizeBaseUrl(window.location.origin);
  }

  return "";
};

export const getAppBasePath = () => normalizeBasePath(ENV_APP_BASE_PATH || "");

export const buildAppPath = (path: string) => {
  if (/^https?:\/\//i.test(path)) return path;

  const basePath = getAppBasePath();
  const normalizedPath = normalizeAppPath(path);

  if (!basePath) return normalizedPath;
  if (normalizedPath === "/") return `${basePath}/`;
  return `${basePath}${normalizedPath}`;
};

export const buildSiteUrl = (path: string) => {
  if (/^https?:\/\//i.test(path)) return path;

  const resolvedPath = buildAppPath(path);
  const base = getSiteUrl();
  if (!base) return resolvedPath;
  return `${base}${resolvedPath}`;
};

export const buildOriginUrl = (path: string) => {
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = normalizeOriginPath(path);
  const base = getSiteUrl();
  if (!base) return normalizedPath;
  return `${base}${normalizedPath}`;
};
